// A band of headline company stats (founded · registered capital · ports · routes).
// Renders as cards on a soft tint band, revealed with a stagger. Owned by Agent D.
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { fadeUp, stagger, revealViewport } from "../motion/variants";

interface StatItem {
  value: string;
  label: string;
}

const KEYS = ["founded", "capital", "domestic", "global"] as const;

export default function StatBand() {
  const { t } = useTranslation("home");

  return (
    <section className="bg-white">
      {/* relative z-10: the -mt-12 overlaps the Hero, which is position:relative and
          would otherwise paint over the cards' top (occluding them). */}
      <div className="relative z-10 mx-auto -mt-12 w-full max-w-6xl px-6">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={revealViewport}
          className="grid grid-cols-2 gap-px overflow-hidden rounded-[var(--radius-lg)] border border-[var(--brand-tint)] bg-[var(--brand-tint)] shadow-[var(--shadow-card)] md:grid-cols-4"
        >
          {KEYS.map((key) => {
            const item = t(`stats.items.${key}`, { returnObjects: true }) as StatItem;
            return (
              <motion.div
                key={key}
                variants={fadeUp}
                className="flex flex-col items-center bg-white px-6 py-10 text-center"
              >
                <span className="font-zh text-[var(--text-3xl)] font-bold leading-none text-[var(--brand-azure)]">
                  {item.value}
                </span>
                <span className="mt-3 text-[var(--text-sm)] text-[var(--brand-slate-text)]">
                  {item.label}
                </span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
